// extracted by mini-css-extract-plugin
export default {"SampleList":"SampleList_SampleList__+WQnB"};